<template>
  <jumbotron>

    <div class="info-message">
      <span>Welcome. Let's Get Started.</span>
    </div>

    <div class="text-danger mt-4" v-show="loginErrors">
      <div
        v-for="error in loginErrors"
        :key="error.code"
      >
        {{ error.code | parseError }}
      </div>
    </div>

    <form class="mt-4">
      <div class="form-group">
        <div class="input-group">
          <input type="text" class="form-control" placeholder="E-mail" v-model="email" :disabled="loggingIn"
                @keyup.enter="doLogin"/>
          <div class="input-group-append">
            <span class="input-group-text"><i class="fas fa-user fa-fw"/></span>
          </div>
        </div>
      </div>

      <div class="form-group">
        <div class="input-group">
          <input type="password" class="form-control" placeholder="Password" v-model="password"
                :disabled="loggingIn" @keyup.enter="doLogin"/>
          <div class="input-group-append">
            <span class="input-group-text"><i class="fas fa-lock fa-fw"/></span>
          </div>
        </div>
        <small class="form-text text-muted text-left">Email address and password are case sensitive.</small>
      </div>
    </form>

    <div class="row">
      <div class="col-sm-7 col-md-8">
        <router-link to="/recover" :disabled="loggingIn">Having trouble logging in?</router-link>
      </div>
      <div class="col-sm-5 col-md-4 text-right">
        <button class="btn btn-outline-primary" :disabled="!email || !password || loggingIn" @click="doLogin"
            style="white-space: nowrap">
          <i class="fas fa-fw" :class="[loginIcon]"/>
          Login
        </button>
      </div>
    </div>

  </jumbotron>
</template>

<script>
import exceptionHandler from '@/common/exception-handler'
import userInfoMixin from '@/common/mixins/user-info-mixin'
import exceptionMixin from '@/common/mixins/exception-mixin'
import jumbotron from '@/common/elements/Jumbotron'
import { mapState, mapActions } from 'vuex'

export default {
  name: 'login',
  mixins: [ userInfoMixin, exceptionMixin ],
  components: { jumbotron },
  data () {
    return {
      email: null,
      password: null,
      loggingIn: false,
      loginErrors: []
    }
  },
  computed: {
    ...mapState('login', ['redirectFrom']),
    loginIcon () {
      return this.loggingIn ? 'fa-sync-alt fa-spin' : 'fa-key'
    }
  },
  methods: {
    ...mapActions('login', ['login']),
    async doLogin () {
      if (!this.email || this.email.length === 0 || !this.password || !this.password.length === 0) {
        return
      }

      this.loggingIn = true
      try {
        await this.login({ email: this.email, password: this.password })

        if (this.redirectFrom) {
          console.log(this.redirectFrom)
          this.$router.push(this.redirectFrom).catch(() => {})
        } else {
          this.$router.push({ name: 'home' }).catch(() => {})
        }
      } catch (error) {
        if (exceptionHandler.isUserError(error)) {
          this.loginErrors = error
        } else {
          this.handleError(error, 'Unable to Login, please try again later.')
        }
      } finally {
        this.loggingIn = false
      }
    }
  }
}
</script>
